<template>
  <!-- LOADING SCREEN -->
  <LoadingScreen v-if="showLoader" @done="loaderDone" />

  <!-- SPLASH / FLYER -->
  <div
    v-if="showFlyer"
    class="flyer-overlay"
    @click="closeFlyer"
  >
    <div class="countdown">
      {{ remaining }} 4
    </div>

    <div class="flyer-box" @click.stop>
      <svg
        class="flyer-border"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        <rect
          x="1"
          y="1"
          width="98"
          height="98"
          rx="12"
          ry="12"
        />
      </svg>

      <img
        :src="flyer"
        alt="Bamboo Sushi – Spécial fêtes"
        class="flyer-image"
      />
    </div>

    <span class="flyer-close">{{ t('flyer_enter_site') }}</span>
  </div>

  <!-- ACCUEIL -->
  <div class="logo">
    <img :src="logo" alt="logo Bamboo Sushi" width="280" />
  </div>

  <nav>
    <ul>
      <li><router-link to="/">{{ t('nav_home') }}</router-link></li>
      <li><router-link to="/Menu" @click="trackMenuClick">{{ t('nav_menu') }}</router-link></li>
     <!-- <li><router-link to="/menu-claude" class="nav-link-new">Menu ✦</router-link></li> -->
      <li><a href="#accueil-2">{{ t('nav_infos') }}</a></li>
    </ul>
  </nav>

  <div class="bloc-gauche">
    <div class="ecran"></div>
  </div>

  <div class="accueil">
    <page1b2 />
  </div>

  <!-- BANNIÈRE INFORMATION -->
  <BlocInformation
    v-if="blocInfo.active"
    :isActive="blocInfo.active"
    :message="blocInfo.message"
    :iconeSelectionnee="blocInfo.icon"
  />

  <div class="accueil-2" id="accueil-2">
<page1b5claude />
    <!-- <page1b3 /> -->
     <page1b3claude />
    <!-- <Reservation /> -->
    <ReservationClaude />
  </div>

  <!-- <BasDePage /> -->
   
  <BasDePageClaude />
</template>

<script setup>
import { ref, reactive, onMounted, onUnmounted } from 'vue'
import { doc, onSnapshot, setDoc, increment } from 'firebase/firestore'
import { db } from '@/assets/firebase'
import { useLocale } from '@/i18n'

import LoadingScreen from '@/components/LoadingScreen.vue'
import page1b2 from '@/components/page-1-b2.vue'
import page1b3claude from '@/components/page-1-b3.vue'
import page1b5claude from '@/components/page-1-b5.vue'
import ReservationClaude from '@/components/reservation.vue'
import BasDePageClaude from '@/components/bas-de-page.vue'
import BlocInformation from '@/components/BlocInformation.vue'
import flyer from '@/images/flyer-bamboosushis-fêtes.png'
import logo from '@/images/logo-transparent.png'

const { t } = useLocale()

/* ===== TRACKING MENU ===== */
function trackMenuClick() {
  const day = new Date().toISOString().split('T')[0]
  setDoc(doc(db, 'stats', 'menu'), {
    total:              increment(1),
    [day.slice(0, 4)]:  increment(1),
    [day.slice(0, 7)]:  increment(1),
    [day]:              increment(1),
  }, { merge: true }).catch(() => {})
}

/* ===== LOADING SCREEN ===== */
const showLoader = ref(!sessionStorage.getItem('siteLoaded'))

function loaderDone() {
  showLoader.value = false
  sessionStorage.setItem('siteLoaded', '1')
}

/* ===== BLOC INFO FIREBASE ===== */
const blocInfo = reactive({
  active: false,
  message: '',
  icon: ''
})

onMounted(() => {
  const refDoc = doc(db, 'config', 'infoBloc')
  onSnapshot(refDoc, snap => {
    if (snap.exists()) Object.assign(blocInfo, snap.data())
  })
})

/* ===== SPLASH ===== */
const showFlyer = ref(true)
const remaining = ref(7)
let timer

const closeFlyer = () => {
  showFlyer.value = false
  clearInterval(timer)
}

onMounted(() => {
  timer = setInterval(() => {
    remaining.value--
    if (remaining.value <= 0) closeFlyer()
  }, 1000)
})

onUnmounted(() => {
  clearInterval(timer)
})
</script>

<style scoped>
/* ── Animations header ───────────────────────────── */
@keyframes fadeDown {
  from { opacity: 0; transform: translateY(-18px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes fadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}
@keyframes heroZoom {
  from { transform: scale(1.05); }
  to   { transform: scale(1); }
}

.logo{
  width:100%;
  height: auto;
  position: relative;
  z-index: 5000;
  animation: fadeDown 0.6s ease 3.8s both;
}
nav {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  position: relative;
  z-index:5000;
  animation: fadeIn 0.6s ease 4.1s both;
}
nav ul {
  list-style: none;
  padding: 0;
  display: flex;
  gap: 10px;
}
 nav a {
  font-family: 'Playfair Display', serif;
  font-weight: 400;
  color: white;
  font-size: 1.25em;
  letter-spacing: 0.05em;
}

nav a.router-link-exact-active {
  color: #8bbf30;
}
.nav-link-new {
  color: #c9a84c !important;
  border: 1px solid rgba(201,168,76,0.4);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 1em;
  transition: background 0.25s, border-color 0.25s;
}
.nav-link-new:hover {
  background: rgba(201,168,76,0.12);
  border-color: #c9a84c;
}
.classActive {
  background-color: blue;
  color: white;
  border-color: blue;
}
.active{
  display:none;
}
.bloc-gauche {
  background-image: url(../images/image.jpg);
  background-color: #030303;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 90vh;
  position: absolute;
  z-index: 1000;
  top:0;
  animation: heroZoom 2.5s ease 6.6s both;
}
.ecran{
  width: 100%;
  height:100%;
  position:absolute;
  top:0;
  background: linear-gradient(to bottom, rgba(3,3,3,0.5) 70%, rgba(20,19,14,0.68) 100%);
  z-index:200;
}
.accueil {
  width: 100%;
  height: calc(90vh - 220px);
  display: flex;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index:500000;
}
.accueil-2 {
  width: 100%;
  height: auto;
  background: linear-gradient(160deg, #1a1912 0%, #13130e 55%, #111110 100%);
  display: flex;
  overflow: hidden;
  flex-direction: column;
  z-index:500000;
  color: #8bbf30;
  padding:0;
  justify-content: center;
  align-items: center;
}
.accueil-2 h1{
  color:#8bbf30;
  font-size: 1.80rem;
}
/* ===== SPLASH ===== */
.flyer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.85);
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 999999;
}

.flyer-box {
  position: relative;
  display: inline-block;
}

.flyer-image {
  display: block;
  max-width: 90vw;
  max-height: 85vh;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.4);
}

.flyer-border {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.flyer-border rect {
  fill: none;
  stroke: #8bbf30;
  stroke-width: 1;
  stroke-dasharray: 392;
  stroke-dashoffset: 392;
  animation: drawBorder 6.5s linear forwards;
}

@keyframes drawBorder {
  to { stroke-dashoffset: 0; }
}

.countdown {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(0,0,0,0.7);
  color: white;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 13px;
}

.flyer-close {
  margin-top: 15px;
  color: white;
  font-size: 14px;
  opacity: 0.7;
}

/* ===== LE RESTE DE TON SITE (inchangé) ===== */
/* .logo {
  position: relative;
  z-index: 5000;
} */


</style>





